import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import qs from 'querystring'
import Api, { paths } from 'shared/services/Api'
import {
  InvoicesDataResponse,
  GetInvoicesDto,
  TableSorting,
  Filters,
  LoadingStatus,
  ActiveInvoice,
  Invoice,
  Contractor,
  SingleNotificationStatus,
} from 'shared/types'
import { getNonEmptyValuesObject } from 'shared/utils'

const NAMESPACE = 'invoices'

export const switchPage = createAction<number>(`${NAMESPACE}/switchPage`)
export const setPageSize = createAction<number>(`${NAMESPACE}/setPageSize`)
export const toggleRow = createAction<Invoice>(`${NAMESPACE}/toggleRow`)
export const toggleAllRows = createAction<boolean>(`${NAMESPACE}/toggleAllRows`)
export const setSorting = createAction<TableSorting>(`${NAMESPACE}/setSorting`)
export const setGetInvoicesLoadingStatus = createAction<LoadingStatus>(
  `${NAMESPACE}/setGetInvoicesLoadingStatus`
)
export const setActiveInvoice = createAction<ActiveInvoice>(
  `${NAMESPACE}/setActiveInvoice`
)
export const resetSendSingleNotificationState = createAction(
  `${NAMESPACE}/resetSendSingleNotificationState`
)
export const clearInvoices = createAction(`${NAMESPACE}/clearInvoices`)
export const clearRowsSelection = createAction(
  `${NAMESPACE}/clearRowsSelection`
)

export const setContractorInvoiceContactDataContactCompletionStatus =
  createAction<{
    contractorId: number
    isContactInfoComplete: boolean
  }>(`${NAMESPACE}/setInvoiceContactDataContactCompletionStatus`)

export const getInvoices = createAsyncThunk<
  { response: InvoicesDataResponse },
  {
    dto: GetInvoicesDto &
      Partial<Record<keyof Filters, Filters[keyof Filters] | string>>
  },
  { rejectValue: string }
>('getInvoices', async ({ dto }, thunkAPI) => {
  try {
    const response = await Api.get(paths.Invoices.root, {
      params: getNonEmptyValuesObject(dto),
      paramsSerializer: params => qs.stringify(params),
    })
    return { response: response.data }
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const sendPreTrialPaymentRequest = createAsyncThunk<
  Blob,
  string | number,
  { rejectValue: { error: string; errorCode: string } }
>(`${NAMESPACE}/sendPreTrialPaymentRequest`, async (invoiceId, thunkAPI) => {
  try {
    const response = await Api.post(
      `${paths.Invoices.root}/${invoiceId}/pre-trial-payment-request/send`,
      undefined,
      {
        responseType: 'blob',
      }
    )
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const sendSingleNotification = createAsyncThunk<
  SingleNotificationStatus,
  { invoiceId: Invoice['id']; contractorName: Contractor['name'] },
  { rejectValue: { error: string; errorCode: string }[] }
>(`${NAMESPACE}/sendSingleNotification`, async ({ invoiceId }, thunkAPI) => {
  try {
    const response = await Api.post(
      `${paths.Invoices.root}/${invoiceId}/notification/send`
    )
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})
